import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03a0736c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content reset-main mt87" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "忘记密码", -1))
const _hoisted_3 = { class: "step-box flex mt90" }
const _hoisted_4 = { class: "num-box flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line line-l" }, null, -1))
const _hoisted_6 = { class: "num mb15" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line line-r" }, null, -1))
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "step-container flex-column-center mt100" }

import { ref, defineAsyncComponent } from 'vue'
import { ElMessage } from 'element-plus';
import checkPc from '@/utils/checkPc'
import { editPasswordApi } from '@/api/login'
import { useRoute, useRouter } from "vue-router"


export default /*#__PURE__*/_defineComponent({
  __name: 'resetPassword',
  setup(__props) {

const router = useRouter();
const route = useRoute();

/**
 * 判断是否PC端
 */
const isPC = checkPc()

// 引入组件
const Layout = defineAsyncComponent(() => import('@/layout/index.vue'));
const LayoutM = defineAsyncComponent(() => import('@/layout/phone/index.vue'));
const TestPhone = defineAsyncComponent(() => import('./components/reset/TestPhone.vue'));
const ResetPass = defineAsyncComponent(() => import('./components/reset/ResetPass.vue'));
const ResetSuccess = defineAsyncComponent(() => import('./components/reset/ResetSuccess.vue'));
const MobileReset = defineAsyncComponent(() => import('./components/reset/MobileReset.vue'));

// 定义变量
const stepList = [
  {name: '验证身份', component: TestPhone},
  {name: '重置登录密码', component: ResetPass},
  {name: '重置成功', component: ResetSuccess}
]
const hasStep = ref(0)

const stepListM = [
  {name: '验证身份', component: MobileReset},
  {name: '重置成功', component: ResetSuccess}
]
const hasStepM = ref(0)

const formData = ref({})

const changeStep = async (e:any) => {
  let { step, data } = e
  if (isPC.value) {
    if (step < 2) hasStep.value = step
    formData.value = { ...formData.value, ...data }
    if (step == 2) {
      // console.log(formData.value, 'formData')
      // 密码修改
      const res:any = await editPasswordApi(formData.value)
      hasStep.value = 2
    }
  } else {
    hasStepM.value = step
  }
}


return (_ctx: any,_cache: any) => {
  return (_unref(isPC))
    ? (_openBlock(), _createBlock(_unref(Layout), {
        key: 0,
        parent: false,
        footer: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stepList, (v, i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: _normalizeClass(['step-item', 'flex-column-center', {'active': i <= hasStep.value}])
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("p", _hoisted_6, _toDisplayString(i + 1), 1),
                    _hoisted_7
                  ]),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(v.name), 1)
                ], 2)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(stepList[hasStep.value].component), { onChangeStep: changeStep }, null, 32))
            ])
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_unref(LayoutM), {
        key: 1,
        parent: false,
        showTab: false
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(stepListM[hasStepM.value].component), { onChangeStep: changeStep }, null, 32))
        ]),
        _: 1
      }))
}
}

})